import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ArrowLeftStrokeIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "arrow-left-stroke",
  "ArrowLeftStrokeIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M4.27738 8.66672L7.47264 11.862L6.52984 12.8048L1.7251 8.00005L6.52984 3.19531L7.47264 4.13812L4.27738 7.33338H14.6679V8.66672H4.27738Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ArrowLeftStrokeIcon;
